import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `legislation`);
        return response;
    } catch (e) { }
}

export async function legislationAdd(informationBody:any) {
    try {
        const response = await apiPost('core', `legislation`, informationBody);
        return response;
    } catch (e) { }
}

export async function legislationUpdate(id: number, informationBody:any) {
    try {
        const response = await apiPut('core', `legislation/${id}`, informationBody);
        return response;
    } catch (e) { }
}

export async function legislationRemove(id: any) {
    try {
        return await apiDelete('core', `legislation/${id}`);
    } catch (e) { }
}